module.exports = __webpack_public_path__ + "static/media/Species-Identification.41c8fe90.png";